<div class="lokos-checkbox">
    <mat-checkbox
        [checked]="checked"
        [disabled]="disabled"
        [labelPosition]="labelPosition"
        (change)="checkedChange.emit($event.checked)"
    >
        <p>
            {{ label | translate }}
        </p>
    </mat-checkbox>
</div>
